<div class="d-flex">
  <div class="tabs-container">
    <mat-tab-group mat-stretch-tabs mat-align-tabs="center" [selectedIndex]="selected.value" (selectedIndexChange)="onTabChange($event)">
      <mat-tab label="Web" i18n-label="@@tabWeb">
        <div class="big-container">
          @if (selectedSection === 1) {
            <div class="d-flex">
              <mat-card appearance="outlined" class="slider-container">
                <mat-card-title i18n="@@whatWeAbleToRegister" class="mat-headline-4 header text-center">What are you able to register</mat-card-title>
                <mat-card-content>
                  <div class="slider-img" style="display: flex;">
                    <mat-icon class="align-self-center" (click)="handlerBack()" color="accent" i18n-aria-label aria-label="Back">keyboard_arrow_left</mat-icon>
                    @if (slideIndex === 0) {
                      <img [@fade] src="../../../assets/images/whatareyou1@3x.png" alt="Slide 1 - Product registration info" i18n-alt="@@altSlide1">
                    }
                    @if (slideIndex === 1) {
                      <img [@fade] src="../../../assets/images/whatareyou2@3x.png" alt="Slide 2 - Product guidance info" i18n-alt="@@altSlide2">
                    }
                    @if (slideIndex === 2) {
                      <img [@fade] src="../../../assets/images/whatareyou3@3x.png" alt="Slide 3 - Product guidance info" i18n-alt="@@altSlide3">
                    }
                    @if (slideIndex === 3) {
                      <img [@fade] src="../../../assets/images/whatareyou4@3x.png" alt="Slide 4 - Product guidance info" i18n-alt="@@altSlide4">
                    }
                    @if (slideIndex === 4) {
                      <img [@fade] src="../../../assets/images/whatareyou5@3x.png" alt="Slide 5 - Event calendar info" i18n-alt="@@altSlide5">
                    }
                    <mat-icon class="align-self-center" (click)="handler()" color="accent" i18n-aria-label aria-label="Next">keyboard_arrow_right</mat-icon>
                  </div>

                  @if (slideIndex === 0) {
                    <div class="text-center slider-text-container">
                      <div i18n="@@whatWeAbleToRegisterFirstText" class="mat-headline-6 slider-text">
                        Manufacturer as well as sales organization can register all kinds of product information such as description, purpose, targeted prospects.
                      </div>
                    </div>
                  }
                  @if (slideIndex === 1) {
                    <div class="text-center slider-text-container">
                      <div i18n="@@whatWeAbleToRegisterSecondText1" class="mat-headline-6 slider-text">
                        Beside the guidance on positioning towards targeted prospects and against competitors along with dedicated support materials, training and marketing materials as well as references.
                      </div>
                    </div>
                  }
                  @if (slideIndex === 2) {
                    <div class="text-center slider-text-container">
                      <div i18n="@@whatWeAbleToRegisterSecondText2" class="mat-headline-6 slider-text">
                        Beside the guidance on positioning towards targeted prospects and against competitors along with dedicated support materials, training and marketing materials as well as references.
                      </div>
                    </div>
                  }
                  @if (slideIndex === 3) {
                    <div class="text-center slider-text-container">
                      <div i18n="@@whatWeAbleToRegisterSecondText3" class="mat-headline-6 slider-text">
                        Beside the guidance on positioning towards targeted prospects and against competitors along with dedicated support materials, training and marketing materials as well as references.
                      </div>
                    </div>
                  }
                  @if (slideIndex === 4) {
                    <div class="text-center slider-text-container">
                      <div i18n="@@whatWeAbleToRegisterThirdText" class="mat-headline-6 slider-text">
                        Product related and prospect related event calendar.
                      </div>
                    </div>
                  }
                  
                  <div style="text-align:center">
                    <span [class]="slideIndex === 0 ? 'dot active': 'dot'" (click)="currentSlide(0)"></span>
                    <span [class]="slideIndex === 1 ? 'dot active': 'dot'" (click)="currentSlide(1)"></span>
                    <span [class]="slideIndex === 2 ? 'dot active': 'dot'" (click)="currentSlide(2)"></span>
                    <span [class]="slideIndex === 3 ? 'dot active': 'dot'" (click)="currentSlide(3)"></span>
                    <span [class]="slideIndex === 4 ? 'dot active': 'dot'" (click)="currentSlide(4)"></span>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          }
      
          <!-- Section 2: Tailoring of information -->
          @if (selectedSection === 2) {
            <div class="d-flex">
              <mat-card appearance="outlined" class="slider-container">
                <mat-card-title i18n="@@tailoringOfInfo" class="mat-headline-4 header text-center">Tailoring of information</mat-card-title>
                <mat-card-content>
                  <div class="slider-img" style="display: flex;">
                    <mat-icon class="align-self-center" (click)="twoHandlerBack()" color="accent" i18n-aria-label aria-label="Back">keyboard_arrow_left</mat-icon>
                    @if (twoSlideIndex === 0) {
                      <img [@fade] src="../../../assets/images/tailoring1@3x.png" alt="Tailoring slide 1" i18n-alt="@@altTailoringSlide1">
                    }
                    @if (twoSlideIndex === 1) {
                      <img [@fade] src="../../../assets/images/tailoring2@3x.png" alt="Tailoring slide 2" i18n-alt="@@altTailoringSlide2">
                    }
                    <mat-icon class="align-self-center" (click)="twoHandler()" color="accent" i18n-aria-label aria-label="Next">keyboard_arrow_right</mat-icon>
                  </div>
                  @if (twoSlideIndex === 0) {
                    <div class="text-center slider-text-container">
                      <div i18n="@@tailoringOfInfoFirstText" class="mat-headline-6 slider-text">
                        Information received from manufacturer can be tailored to local specific requirements by selecting what is shared with the sales reps through the mobile application.
                      </div>
                    </div>
                  }
                  @if (twoSlideIndex === 1) {
                    <div class="text-center slider-text-container">
                      <div i18n="@@tailoringOfInfoSecondText" class="mat-headline-6 slider-text">
                        In additional it can be further tailored by adding own locally applicable content such as translated brochures and or local publications and references.
                      </div>
                    </div>
                  }
                  <div style="text-align:center">
                    <span [class]="twoSlideIndex === 0 ? 'dot active': 'dot'" (click)="twoCurrentSlide(0)"></span>
                    <span [class]="twoSlideIndex === 1 ? 'dot active': 'dot'" (click)="twoCurrentSlide(1)"></span>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          }

          <!-- Section 3: Safely share content -->
          @if (selectedSection === 3) {
            <div class="d-flex">
              <mat-card appearance="outlined" class="slider-container">
                <mat-card-title i18n="@@safelyShareYourContent" class="mat-headline-4 header text-center">Safely share your content with those that need it</mat-card-title>
                <mat-card-content>
                  <img class="slider-img" style="margin-right: auto;" [@fade] src="../../../assets/images/safely@3x.png" alt="Secure sharing" i18n-alt="@@altSafelyShareContent">
                  <div class="text-center slider-text-container">
                    <div i18n="@@safelyShareYourContentText" class="mat-headline-6 slider-text">
                      You have full control with whom your content is shared. Sharing of content works through an product-specific approval system which can be managed to revoke and provided approvals.
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          }

          <!-- Section 4: Improving your content -->
          @if (selectedSection === 4) {
            <div class="d-flex">
              <mat-card appearance="outlined" class="slider-container">
                <mat-card-title i18n="@@improveYourContent" class="mat-headline-4 header text-center">Improving your content</mat-card-title>
                <mat-card-content>
                  <img class="slider-img" style="margin-right: auto;" [@fade] src="../../../assets/images/improvingContent@3x.png" alt="Improve content" i18n-alt="@@altImproveContent">
                  <div class="text-center slider-text-container">
                    <div i18n="@@improveYourContentText" class="mat-headline-6 slider-text">
                      Sales Script provides clear insights in the usage of shared content and enables to receive and review feedback on the registered content. This will allow for further tailoring as well as improving the provided content.                    
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          }

          <!-- Section 5: Valid information -->
          @if (selectedSection === 5) {
            <div class="d-flex">
              <mat-card appearance="outlined" class="slider-container">
                <mat-card-title i18n="@@validInfoAndMaterials" class="mat-headline-4 header text-center">Valid information and materials only!</mat-card-title>
                <mat-card-content>
                  <div class="slider-img" style="display: flex;">
                    <mat-icon class="align-self-center" (click)="twoHandlerBack()" color="accent" i18n-aria-label aria-label="Back">keyboard_arrow_left</mat-icon>
                    @if (twoSlideIndex === 0) {
                      <img [@fade] src="../../../assets/images/validInfo1@3x.png" alt="Valid info slide 1" i18n-alt="@@altValidInfoSlide1">
                    }
                    @if (twoSlideIndex === 1) {
                      <img [@fade] src="../../../assets/images/validInfo2@3x.png" alt="Valid info slide 2" i18n-alt="@@altValidInfoSlide2">
                    }
                    <mat-icon class="align-self-center" (click)="twoHandler()" color="accent" i18n-aria-label aria-label="Next">keyboard_arrow_right</mat-icon>
                  </div>
                  @if (twoSlideIndex === 0) {
                    <div class="text-center slider-text-container">
                      <div i18n="@@validInfoAndMaterialsFirstText" class="mat-headline-6 slider-text">
                        Any additions or changes made to the registered information will be subjected to review prior to being shared through the mobile applications while any removal of content will automatically result removal from the entire database and will no longer be available for sharing or use.
                      </div>
                    </div>
                  }
                  @if (twoSlideIndex === 1) {
                    <div class="text-center slider-text-container">
                      <div i18n="@@validInfoAndMaterialsSecondText" class="mat-headline-6 slider-text">
                        Certificates are subjected to expiry dates and any expired document will be no longer shared and therefor cant’s be used.
                      </div>
                    </div>
                  }
                  <div style="text-align:center;">
                    <span [class]="twoSlideIndex === 0 ? 'dot active': 'dot'" (click)="twoCurrentSlide(0)"></span>
                    <span [class]="twoSlideIndex === 1 ? 'dot active': 'dot'" (click)="twoCurrentSlide(1)"></span>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          }
        </div>
      </mat-tab>

      <!-- Mobile Tab -->
      <mat-tab label="Mobile Application" i18n-label="@@tabMobileApplication">
        <div class="big-container">
          @if (mobileSelectedSection === 1) {
            <div class="d-flex">
              <mat-card appearance="outlined" class="slider-container">
                <mat-card-title i18n="@@interactiveAllProducts" class="mat-headline-4 header text-center">
                  Interactive guide to all product related information & company information
                </mat-card-title>
                <mat-card-content>
                  <div class="slider-img" style="display: flex;">
                    <mat-icon class="align-self-center left-arrow-mobile" (click)="mobileHandlerBack()" color="accent" i18n-aria-label aria-label="Back">keyboard_arrow_left</mat-icon>
                    @if (slideIndexMobile === 0) {
                      <img [@fade] src="../../../assets/images/interactive-ipad@3x.png" alt="Interactive slide 1" i18n-alt="@@altMobileSlide1">
                    }
                    @if (slideIndexMobile === 1) {
                      <img [@fade] src="../../../assets/images/interactive-ipad2@3x.png" alt="Interactive slide 2" i18n-alt="@@altMobileSlide2">
                    }
                    @if (slideIndexMobile === 2) {
                      <img [@fade] src="../../../assets/images/interactive-ipad3@3x.png" alt="Interactive slide 3" i18n-alt="@@altMobileSlide3">
                    }
                    @if (slideIndexMobile === 3) {
                      <img [@fade] src="../../../assets/images/interactive-ipad4@3x.png" alt="Interactive slide 4" i18n-alt="@@altMobileSlide4">
                    }
                    @if (slideIndexMobile === 4) {
                      <img [@fade] src="../../../assets/images/interactive-ipad5@3x.png" alt="Interactive slide 5" i18n-alt="@@altMobileSlide5">
                    }
                    <mat-icon class="align-self-center" (click)="mobileHandler()" color="accent" i18n-aria-label aria-label="Next">keyboard_arrow_right</mat-icon>
                  </div>

                  <!-- Mobile slide texts -->
                  @if (slideIndexMobile === 0) {
                    <div class="text-center slider-text-container">
                      <div i18n="@@interactiveAllProductsText1" class="mat-headline-6 slider-text">
                        The interactive guide will guide the user on how to position the products towards the intended prospect, on how to position the product against its competitors and how to use the materials provided.
                      </div>
                    </div>
                  }
                  @if (slideIndexMobile === 1) {
                    <div class="text-center slider-text-container">
                      <div i18n="@@interactiveAllProductsText2" class="mat-headline-6 slider-text">
                        The interactive guide will guide the user on how to position the products towards the intended prospect, on how to position the product against its competitors and how to use the materials provided.
                      </div>
                    </div>
                  }
                  @if (slideIndexMobile === 2) {
                    <div class="text-center slider-text-container">
                      <div i18n="@@interactiveAllProductsText3" class="mat-headline-6 slider-text">
                        The interactive guide will guide the user on how to position the products towards the intended prospect, on how to position the product against its competitors and how to use the materials provided.
                      </div>
                    </div>
                  }
                  @if (slideIndexMobile === 3) {
                    <div class="text-center slider-text-container">
                      <div i18n="@@interactiveAllProductsText4" class="mat-headline-6 slider-text">
                        The interactive guide will guide the user on how to position the products towards the intended prospect, on how to position the product against its competitors and how to use the materials provided.
                      </div>
                    </div>
                  }
                  @if (slideIndexMobile === 4) {
                    <div class="text-center slider-text-container">
                      <div i18n="@@interactiveAllProductsText5" class="mat-headline-6 slider-text">
                        The interactive guide will guide the user on how to position the products towards the intended prospect, on how to position the product against its competitors and how to use the materials provided.
                      </div>
                    </div>
                  }
                  <div style="text-align:center">
                    <span [class]="slideIndexMobile === 0 ? 'dot active': 'dot'" (click)="currentSlideMobile(0)"></span>
                    <span [class]="slideIndexMobile === 1 ? 'dot active': 'dot'" (click)="currentSlideMobile(1)"></span>
                    <span [class]="slideIndexMobile === 2 ? 'dot active': 'dot'" (click)="currentSlideMobile(2)"></span>
                    <span [class]="slideIndexMobile === 3 ? 'dot active': 'dot'" (click)="currentSlideMobile(3)"></span>
                    <span [class]="slideIndexMobile === 4 ? 'dot active': 'dot'" (click)="currentSlideMobile(4)"></span>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          }
          @if (mobileSelectedSection === 2 ) {
            <div class="d-flex">
              <mat-card appearance="outlined" class="slider-container">
                <mat-card-title i18n="@@simulateCrossSelling" class="mat-headline-4 header text-center">Stimulate cross selling</mat-card-title>
                <mat-card-content>
                  <div class="slider-img" style="display: flex;">
                    <mat-icon class="align-self-center left-arrow-mobile" (click)="threeHandlerBack()" color="accent" i18n-aria-label aria-label="Back">keyboard_arrow_left</mat-icon>
                    @if (threeSlideIndex === 0) {
                      <img [@fade] src="../../../assets/images/simulate-ipad1@3x.png" alt="Simulate slide 1" i18n-alt="@@altSimulateSlide1">
                    }
                    @if (threeSlideIndex === 1) {
                      <img [@fade] src="../../../assets/images/simulate-ipad2@3x.png" alt="Simulate slide 2" i18n-alt="@@altSimulateSlide2">
                    }
                    @if (threeSlideIndex === 2) {
                      <img [@fade] src="../../../assets/images/simulate-ipad3@3x.png" alt="Simulate slide 3" i18n-alt="@@altSimulateSlide3">
                    }
                    <mat-icon class="align-self-center" (click)="threeHandler()" color="accent" i18n-aria-label aria-label="Next">keyboard_arrow_right</mat-icon>
                  </div>
                  @if (threeSlideIndex === 0) {
                    <div class="text-center slider-text-container">
                      <div i18n="@@simulateCrossSellingText1" class="mat-headline-6 slider-text">
                        It will demonstrate cross selling opportunities by displaying a list of intended prospects but also allow you to show which products are targeted towards the different prospects.
                      </div>
                    </div>
                  }
                  @if (threeSlideIndex === 1) {
                    <div class="text-center slider-text-container">
                      <div i18n="@@simulateCrossSellingText2" class="mat-headline-6 slider-text">
                        It will demonstrate cross selling opportunities by displaying a list of intended prospects but also allow you to show which products are targeted towards the different prospects.
                      </div>
                    </div>
                  }
                  @if (threeSlideIndex === 2) {
                    <div class="text-center slider-text-container">
                      <div i18n="@@simulateCrossSellingText3" class="mat-headline-6 slider-text">
                        It will demonstrate cross selling opportunities by displaying a list of intended prospects but also allow you to show which products are targeted towards the different prospects.
                      </div>
                    </div>
                  }
                  <div style="text-align:center">
                    <span [class]="threeSlideIndex === 0 ? 'dot active': 'dot'" (click)="threeCurrentSlide(0)"></span>
                    <span [class]="threeSlideIndex === 1 ? 'dot active': 'dot'" (click)="threeCurrentSlide(1)"></span>
                    <span [class]="threeSlideIndex === 2 ? 'dot active': 'dot'" (click)="threeCurrentSlide(2)"></span>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          }
          @if (mobileSelectedSection === 3 ) {
            <div class="d-flex">
              <mat-card appearance="outlined" class="slider-container">
                <mat-card-title i18n="@@alwaysUpToDate" class="mat-headline-4 header text-center">Always up to date </mat-card-title>
                <mat-card-content>
                  <img style="margin-right: auto;" class="slider-img" [@fade] src="../../../assets/images/upToDate-ipad@3x.png" alt="Always up to date" i18n-alt="@@altAlwaysUpToDate">
                  <div class="text-center slider-text-container">
                    <div i18n="@@alwaysUpToDateText" class="mat-headline-6 slider-text">
                      Any content provided through the device is sure to be the latest content. Any updates, edits or changes to the registered content will be shared after approval and obsolete and old information will be deleted in real time. Be certain to always send the right support materials and or certificate.
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          }
          @if (mobileSelectedSection === 4 ) {
            <div class="d-flex">
              <mat-card appearance="outlined" class="slider-container">
                <mat-card-title i18n="@@sharingDigitalContent" class="mat-headline-4 header text-center">Sharing digital content whenever you need to</mat-card-title>
                <mat-card-content>
                  <div class="slider-img" style="display: flex;">
                    <mat-icon class="align-self-center left-arrow-mobile" (click)="handlerBack()" color="accent" i18n-aria-label aria-label="Back">keyboard_arrow_left</mat-icon>
                    @if (slideIndex === 0) {
                      <img [@fade] src="../../../assets/images/sharingDigital-ipad1@3x.png" alt="Sharing slide 1" i18n-alt="@@altSharingSlide1">
                    }
                    @if (slideIndex === 1) {
                      <img [@fade] src="../../../assets/images/sharingDigital-ipad2@3x.png" alt="Sharing slide 2" i18n-alt="@@altSharingSlide2">
                    }
                    @if (slideIndex === 2) {
                      <img [@fade] src="../../../assets/images/sharingDigital-ipad3@3x.png" alt="Sharing slide 3" i18n-alt="@@altSharingSlide3">
                    }
                    @if (slideIndex === 3) {
                      <img [@fade] src="../../../assets/images/sharingDigital-ipad4@3x.png" alt="Sharing slide 4" i18n-alt="@@altSharingSlide4">
                    }
                    @if (slideIndex === 4) {
                      <img [@fade] src="../../../assets/images/sharingDigital-ipad5@3x.png" alt="Sharing slide 5" i18n-alt="@@altSharingSlide5">
                    }
                    <mat-icon class="align-self-center" (click)="handler()" color="accent" i18n-aria-label aria-label="Next">keyboard_arrow_right</mat-icon>
                  </div>
                  @if (slideIndex === 0) {
                    <div class="text-center slider-text-container">
                      <div i18n="@@sharingDigitalContentText" class="mat-headline-6 slider-text">
                        With the mobile application you have access to all the uploaded support materials as well as the reference list and product event calendar. Al this information can be shared with your intended prospect where and when needed.
                      </div>
                    </div>
                  }
                  @if (slideIndex === 1) {
                    <div class="text-center slider-text-container">
                      <div i18n="@@sharingDigitalContentText1" class="mat-headline-6 slider-text">
                        With the mobile application you have access to all the uploaded support materials as well as the reference list and product event calendar. Al this information can be shared with your intended prospect where and when needed.
                      </div>
                    </div>
                  }
                  @if (slideIndex === 2) {
                    <div class="text-center slider-text-container">
                      <div i18n="@@sharingDigitalContentText2" class="mat-headline-6 slider-text">
                        With the mobile application you have access to all the uploaded support materials as well as the reference list and product event calendar. Al this information can be shared with your intended prospect where and when needed.
                      </div>
                    </div>
                  }
                  @if (slideIndex === 3) {
                    <div class="text-center slider-text-container">
                      <div i18n="@@sharingDigitalContentText3" class="mat-headline-6 slider-text">
                        With the mobile application you have access to all the uploaded support materials as well as the reference list and product event calendar. Al this information can be shared with your intended prospect where and when needed.
                      </div>
                    </div>
                  }
                  @if (slideIndex === 4) {
                    <div class="text-center slider-text-container">
                      <div i18n="@@sharingDigitalContentText4" class="mat-headline-6 slider-text">
                        With the mobile application you have access to all the uploaded support materials as well as the reference list and product event calendar. Al this information can be shared with your intended prospect where and when needed.
                      </div>
                    </div>
                  }
                  <div style="text-align:center">
                    <span [class]="slideIndex === 0 ? 'dot active': 'dot'" (click)="currentSlide(0)"></span>
                    <span [class]="slideIndex === 1 ? 'dot active': 'dot'" (click)="currentSlide(1)"></span>
                    <span [class]="slideIndex === 2 ? 'dot active': 'dot'" (click)="currentSlide(2)"></span>
                    <span [class]="slideIndex === 3 ? 'dot active': 'dot'" (click)="currentSlide(3)"></span>
                    <span [class]="slideIndex === 4 ? 'dot active': 'dot'" (click)="currentSlide(4)"></span>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          }
          @if (mobileSelectedSection === 5 ) {
            <div class="d-flex">
              <mat-card appearance="outlined" class="slider-container">
                <mat-card-title i18n="@@registrationSalesCall" class="mat-headline-4 header text-center">Registration of your sales call</mat-card-title>
                <mat-card-content>
                  <div class="slider-img" style="display: flex;">
                    <mat-icon class="align-self-center left-arrow-mobile" (click)="fourHandlerBack()" color="accent" i18n-aria-label aria-label="Back">keyboard_arrow_left</mat-icon>
                    @if (fourSlideIndex === 0) {
                      <img [@fade] src="../../../assets/images/registration-ipad1@3x.png" alt="Registration slide 1" i18n-alt="@@altRegistrationSlide1">
                    }
                    @if (fourSlideIndex === 1) {
                      <img [@fade] src="../../../assets/images/registration-ipad2@3x.png" alt="Registration slide 2" i18n-alt="@@altRegistrationSlide2">
                    }
                    @if (fourSlideIndex === 2) {
                      <img [@fade] src="../../../assets/images/registration-ipad3@3x.png" alt="Registration slide 3" i18n-alt="@@altRegistrationSlide3">
                    }
                    @if (fourSlideIndex === 3) {
                      <img [@fade] src="../../../assets/images/registration-ipad4@3x.png" alt="Registration slide 4" i18n-alt="@@altRegistrationSlide4">
                    }
                    <mat-icon class="align-self-center" (click)="fourHandler()" color="accent" i18n-aria-label aria-label="Next">keyboard_arrow_right</mat-icon>
                  </div>
                  @if (fourSlideIndex === 0) {
                    <div class="text-center slider-text-container">
                      <div i18n="@@registrationSalesCallText1" class="mat-headline-6 slider-text">
                        The mobile application allows you to register your sales call and enables you the add content based meeting subjects to your call report. These could be any of the discussed and shared product information, support materials, certificates, event calendar entries or references. You can finish it off by setting your follow up activities which can be automatically scheduled in your agenda.
                      </div>
                    </div>
                  }
                  @if (fourSlideIndex === 1) {
                    <div class="text-center slider-text-container">
                      <div i18n="@@registrationSalesCallText2" class="mat-headline-6 slider-text">
                        The mobile application allows you to register your sales call and enables you the add content based meeting subjects to your call report. These could be any of the discussed and shared product information, support materials, certificates, event calendar entries or references. You can finish it off by setting your follow up activities which can be automatically scheduled in your agenda.
                      </div>
                    </div>
                  }
                  @if (fourSlideIndex === 2) {
                    <div class="text-center slider-text-container">
                      <div i18n="@@registrationSalesCallText3" class="mat-headline-6 slider-text">
                        The mobile application allows you to register your sales call and enables you the add content based meeting subjects to your call report. These could be any of the discussed and shared product information, support materials, certificates, event calendar entries or references. You can finish it off by setting your follow up activities which can be automatically scheduled in your agenda.
                      </div>
                    </div>
                  }
                  @if (fourSlideIndex === 3) {
                    <div class="text-center slider-text-container">
                      <div i18n="@@registrationSalesCallText4" class="mat-headline-6 slider-text">
                        The mobile application allows you to register your sales call and enables you the add content based meeting subjects to your call report. These could be any of the discussed and shared product information, support materials, certificates, event calendar entries or references. You can finish it off by setting your follow up activities which can be automatically scheduled in your agenda.
                      </div>
                    </div>
                  }
                  <div style="text-align:center">
                    <span [class]="fourSlideIndex === 0 ? 'dot active': 'dot'" (click)="fourCurrentSlide(0)"></span>
                    <span [class]="fourSlideIndex === 1 ? 'dot active': 'dot'" (click)="fourCurrentSlide(1)"></span>
                    <span [class]="fourSlideIndex === 2 ? 'dot active': 'dot'" (click)="fourCurrentSlide(2)"></span>
                    <span [class]="fourSlideIndex === 3 ? 'dot active': 'dot'" (click)="fourCurrentSlide(3)"></span>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          }
          @if (mobileSelectedSection === 6 ) {
            <div class="d-flex">
              <mat-card appearance="outlined" class="app-card flex-grow">
                <mat-card-content>
                  <img class="app-image" src="{{utils.isDarkMode() ? '../../../assets/images/get-the-app-dark.svg' : '../../../assets/images/get-the-app.svg'}}">
                  <div class="app-content">
                    <div i18n="@@wantToIncreaseSales" class="mat-headline-4 margin-33">Want to Increase your sales?</div>
                    <div i18n="@@availableOnIOSAndAndroid" class="mat-headline-6 margin-8">Sales Script will be available for on iOS and Android.</div>
                    <div i18n="@@availableOnPhonesAndTablets" class="mat-headline-6 margin-33">both for Smartphones and Tablets</div>
                    <div class="d-flex buttons-container">
                      <a target="_blank" href="https://apps.apple.com/us/app/s2cript/id1620185340">
                        <img src="../../../assets/images/app-store.png" alt="App Store" i18n-alt="@@altAppStore">
                      </a>
                      <a class="ml-mobile" target="_blank" href="https://play.google.com/store/apps/details?id=com.Sales.Script&hl=en&gl=US">
                        <img src="../../../assets/images/google-play.png" alt="Google Play" i18n-alt="@@altGooglePlay">
                      </a>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          }
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
  <div>
    <mat-icon (click)="openVideo()" class="video-icon cursor" color="accent" i18n-aria-label aria-label="Play video">smart_display</mat-icon>
    @if (selected.value === 1) {
      <div class="vertical-scroll-container">
        <div class="d-flex mt-auto">
          <a (click)="navigateToSectionMobile( 1)" class="{{(mobileSelectedSection === 1 ? 'vertical-dot mt-auto' : 'vertical-dot-not-active mt-auto')}}"></a>
          @if (mobileSelectedSection === 1 && !utils.isMobile()) {
            <div i18n="@@interactiveGuide" class="mat-subtitle-1 ml-10 font-14">
              Interactive guide
            </div>
          }
          @if (mobileSelectedSection !== 1 && !utils.isMobile()) {
            <div i18n="@@interactiveGuide" class="mat-caption ml-10 font-14">
              Interactive guide
            </div>
          }
        </div>
        <div class="d-flex">
          <a (click)="navigateToSectionMobile( 2)" class="{{(mobileSelectedSection === 2 ? 'vertical-dot' : 'vertical-dot-not-active')}}"></a>
          @if (mobileSelectedSection === 2 && !utils.isMobile()) {
            <div i18n="@@simulateCrossSelling" class="mat-subtitle-1 ml-10 font-14">
              Stimulate cross selling
            </div>
          }
          @if (mobileSelectedSection !== 2 && !utils.isMobile()) {
            <div i18n="@@simulateCrossSelling" class="mat-caption ml-10 font-14">
              Stimulate cross selling
            </div>
          }
        </div>
        <div class="d-flex">
          <a (click)="navigateToSectionMobile( 3)" class="{{(mobileSelectedSection === 3 ? 'vertical-dot' : 'vertical-dot-not-active')}}"></a>
          @if (mobileSelectedSection === 3 && !utils.isMobile()) {
            <div i18n="@@alwaysUpToDate" class="mat-subtitle-1 ml-10 font-14">
              Always up to date
            </div>
          }
          @if (mobileSelectedSection !== 3 && !utils.isMobile()) {
            <div i18n="@@alwaysUpToDate" class="mat-caption ml-10 font-14">
              Always up to date
            </div>
          }
        </div>
        <div class="d-flex">
          <a (click)="navigateToSectionMobile( 4)" class="{{(mobileSelectedSection === 4 ? 'vertical-dot' : 'vertical-dot-not-active')}}"></a>
          @if (mobileSelectedSection === 4 && !utils.isMobile()) {
            <div i18n="@@sharingContent" class="mat-subtitle-1 ml-10 font-14">
              Sharing content
            </div>
          }
          @if (mobileSelectedSection !== 4 && !utils.isMobile()) {
            <div i18n="@@sharingContent" class="mat-caption ml-10 font-14">
              Sharing content
            </div>
          }
        </div>
        <div class="d-flex">
          <a (click)="navigateToSectionMobile( 5)" class="{{(mobileSelectedSection === 5 ? 'vertical-dot mb-auto' : 'vertical-dot-not-active mb-auto')}}"></a>
          @if (mobileSelectedSection === 5 && !utils.isMobile()) {
            <div i18n="@@registeringSalesCalles" class="mat-subtitle-1 ml-10 font-14">
              Registering sales calles
            </div>
          }
          @if (mobileSelectedSection !== 5 && !utils.isMobile()) {
            <div i18n="@@registeringSalesCalles" class="mat-caption ml-10 font-14">
              Registering sales calles
            </div>
          }
        </div>
        <div class="d-flex mb-auto" style="margin-top: 16px">
          <a (click)="navigateToSectionMobile( 6)" class="{{(mobileSelectedSection === 6 ? 'vertical-dot mb-auto' : 'vertical-dot-not-active mb-auto')}}"></a>
          @if (mobileSelectedSection === 6 && !utils.isMobile()) {
            <div i18n="@@getTheApp" class="mat-subtitle-1 ml-10 font-14">
              Get the app
            </div>
          }
          @if (mobileSelectedSection !== 6 && !utils.isMobile()) {
            <div i18n="@@getTheApp" class="mat-caption ml-10 font-14">
              Get the app
            </div>
          }
        </div>
      </div>
    }
    @if (selected.value === 0) {
      <div class="vertical-scroll-container">
        <div class="d-flex mt-auto">
          <a (click)="navigateToSection( 1)" class="{{(selectedSection === 1 ? 'vertical-dot mt-auto' : 'vertical-dot-not-active mt-auto')}}"></a>
          @if (selectedSection === 1 && !utils.isMobile()) {
            <div i18n="@@registeringInfo" class="mat-subtitle-1 ml-10 font-14">
              Registering Information
            </div>
          }
          @if (selectedSection !== 1 && !utils.isMobile()) {
            <div i18n="@@registeringInfo" class="mat-caption ml-10 font-14">
              Registering Information
            </div>
          }
        </div>
        <div class="d-flex">
          <a (click)="navigateToSection( 2)" class="{{(selectedSection === 2 ? 'vertical-dot' : 'vertical-dot-not-active')}}"></a>
          @if (selectedSection === 2 && !utils.isMobile()) {
            <div i18n="@@tailoringOfInfo" class="mat-subtitle-1 ml-10 font-14">
              Tailoring of information
            </div>
          }
          @if (selectedSection !== 2 && !utils.isMobile()) {
            <div i18n="@@tailoringOfInfo" class="mat-caption ml-10 font-14">
              Tailoring of information
            </div>
          }
        </div>
        <div class="d-flex">
          <a (click)="navigateToSection( 3)" class="{{(selectedSection === 3 ? 'vertical-dot' : 'vertical-dot-not-active')}}"></a>
          @if (selectedSection === 3 && !utils.isMobile()) {
            <div i18n="@@contentSharing" class="mat-subtitle-1 ml-10 font-14">
              Content sharing
            </div>
          }
          @if (selectedSection !== 3 && !utils.isMobile()) {
            <div i18n="@@contentSharing" class="mat-caption ml-10 font-14">
              Content sharing
            </div>
          }
        </div>
        <div class="d-flex">
          <a (click)="navigateToSection( 4)" class="{{(selectedSection === 4 ? 'vertical-dot' : 'vertical-dot-not-active')}}"></a>
          @if (selectedSection === 4 && !utils.isMobile()) {
            <div i18n="@@improvingContent" class="mat-subtitle-1 ml-10 font-14">
              Improving content
            </div>
          }
          @if (selectedSection !== 4 && !utils.isMobile()) {
            <div i18n="@@improvingContent" class="mat-caption ml-10 font-14">
              Improving content
            </div>
          }
        </div>
        <div class="d-flex mb-auto">
          <a (click)="navigateToSection(5)"class="{{(selectedSection === 5 ? 'vertical-dot mb-auto' : 'vertical-dot-not-active mb-auto')}}"></a>
          @if (selectedSection === 5 && !utils.isMobile()) {
            <div i18n="@@validInfo" class="mat-subtitle-1 ml-10 font-14">
              Valid information
            </div>
          }
          @if (selectedSection !== 5 && !utils.isMobile()) {
            <div i18n="@@validInfo" class="mat-caption ml-10 font-14">
              Valid information
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>
